import constants from '../Constants';
const {
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  RESET_LOADING,
  RESET_SUCCESS,
  RESET_FAIL,
  REQUEST_RESET_LOADING,
  REQUEST_RESET_SUCCESS,
  REQUEST_RESET_FAIL,
  HIDE_DROPDOWN,
  LOGOUT,
} = constants;

const INIT_STATE = {
  loading: { login: false, reset: false, requestReset: false },
  user: false,
  alert: { login: false, reset: false, requestReset: false },
  permissions: {},
  token: false,
};

const AuthReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_LOADING:
      return { ...state, loading: { login: true, reset: false, requestReset: false } };
    case LOGIN_SUCCESS:
      return {
        ...state, 
        loading: { login: false, reset: false, requestReset: false },
        user: action.payload.user,
        token: action.payload.token,
        permissions: action.payload.permissions,
        alert: { login: { type: 'success', message: 'Logging in ...'}, reset: false, requestReset: false },
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: { login: false, reset: false, requestReset: false },
        alert: { login: { type: 'warning', message: action.payload}, reset: false, requestReset: false},
      };

    case RESET_LOADING:
      return { ...state, loading: { reset: true, login: false, requestReset: false}};

    case RESET_SUCCESS:
      return {
        ...state,
        loading: { login: false, reset: false, requestReset: false },
        alert: { login: false, reset: {type: 'success', message: 'Password changed successfully.'}, requestReset: false}
      };

      case RESET_FAIL:
      return {
        ...state,
        loading: { login: false, reset: false, requestReset: false },
        alert: { login: false, reset: { type: 'warning', message: action.payload }, requestReset: false }
      };

      case REQUEST_RESET_LOADING:
      return { ...state, loading: { reset: false, login: false, requestReset: true}};

    case REQUEST_RESET_SUCCESS:
      return {
        ...state,
        loading: { login: false, reset: false, requestReset: false },
        alert: { login: false, requestReset: {type: 'success', message: 'An email has been sent to you with the new password.'}, reset: false}
      };

      case REQUEST_RESET_FAIL:
      return {
        ...state,
        loading: { login: false, reset: false, requestReset: false },
        alert: { login: false, requestReset: { type: 'warning', message: action.payload }, reset: false }
      };

    
    case HIDE_DROPDOWN:
      return {
        ...state, alert: false,
      };
    case LOGOUT:
      return INIT_STATE;
    default:
      return state;
  }
};

export default AuthReducer;



// WEBPACK FOOTER //
// ./src/Reducers/AuthReducer.js